module.exports = __webpack_public_path__ + "img/w3_percent_grey.0feca83e.png";